import { Badge, Collapse, Flex, Space, Typography } from 'antd'
import { useBudgetListOwn } from 'src/pages/budget/budgetRequests/hooks'
import { OwnTable, OwnEmpty } from './components'
import styles from './styles.module.css'
import { TStatusPeriod } from 'src/pages/budget/types'

type Props = {
  budgetPeriodName: string | null
  currentPeriodStatus?: TStatusPeriod
}

export const RequestListOwn = ({
  budgetPeriodName,
  currentPeriodStatus,
}: Props) => {
  const { budgetListOwnAll, budgetListOwn, filteredBudgetListOwn } =
    useBudgetListOwn()
  const { Text } = Typography

  if (!budgetListOwn || !filteredBudgetListOwn || !budgetListOwnAll) return null
  if (budgetListOwnAll.length !== 0 && budgetListOwn.length === 0) return null
  if (budgetListOwn.length === 0)
    return <OwnEmpty budgetPeriodName={budgetPeriodName} />
  return (
    <Flex vertical gap="middle">
      <Collapse
        items={[
          {
            key: '1',
            label: (
              <Space>
                <Text strong style={{ fontSize: 28 }}>
                  Мои заявки / {budgetPeriodName ?? ''}
                </Text>
                <Badge
                  count={filteredBudgetListOwn.length}
                  showZero
                  color="white"
                  style={{ color: 'black', borderRadius: '4px' }}
                />
              </Space>
            ),
            children: (
              <Flex
                align="center"
                justify="center"
                style={{ minHeight: '15em' }}
              >
                <OwnTable
                  list={budgetListOwn}
                  filterList={filteredBudgetListOwn}
                  currentPeriodStatus={currentPeriodStatus}
                />
              </Flex>
            ),
          },
        ]}
        defaultActiveKey="1"
        className={styles.collapse}
        expandIconPosition="end"
        style={{ backgroundColor: 'var(--color-blue-20)' }}
      />
    </Flex>
  )
}
